// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Columns } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconColumns(props: any) {
    return <IconBase icon={Columns} {...props} />
  }

  export default IconColumns
  